// extracted by mini-css-extract-plugin
export var card = "_91-0";
export var failedIcon = "_91-4";
export var failedIconBadge = "_91-3";
export var icon = "_91-1";
export var successIcon = "_91-2";